export enum Endpoint {
    // realmManager
    realmManager_calculateStorageUsage = 'realmManager/calculateStorageUsage',
    realmManager_createAlertConditions = 'realmManager/createAlertConditions',
    realmManager_createNodeNFSStorageArea = 'realmManager/createNodeNFSStorageArea',
    realmManager_createRemoteNFSStorageArea = 'realmManager/createRemoteNFSStorageArea',
    realmManager_createSession = 'realmManager/createSession',
    realmManager_createSystemStorageDepot = 'realmManager/createSystemStorageDepot',
    realmManager_createNode = 'realmManager/createNode',
    realmManager_updateNode = 'realmManager/updateNode',
    realmManager_updateNodes = 'realmManager/updateNodes',
    realmManager_deleteStorageArea = 'realmManager/deleteStorageArea',
    realmManager_expressProvision = 'realmManager/expressProvision',
    realmManager_getAllFieldsDocumentMetadataTemplate = 'realmManager/getAllFieldsDocumentMetadataTemplate',
    realmManager_getAllFileTypes = 'realmManager/getAllFileTypes',
    realmManager_getAllProjectsDownloadUrl = 'realmManager/getAllProjectsDownloadUrl',
    realmManager_getDeletedProjectAuditLogUrl = 'realmManager/getDeletedProjectAuditLogUrl',
    realmManager_getDREnumNames = 'realmManager/getDREnumNames',
    realmManager_getLicensedFeatures = 'realmManager/getLicensedFeatures',
    realmManager_getLicenseInfo = 'realmManager/getLicenseInfo',
    realmManager_getMailServerConfig = 'realmManager/getMailServerConfig',
    realmManager_getMetadataFieldDescriptions = 'realmManager/getMetadataFieldDescriptions',
    realmManager_getMetadataFieldProperties = 'realmManager/getMetadataFieldProperties',
    realmManager_getNodeStatus = 'realmManager/getNodeStatus',
    realmManager_getPasswordPolicy = 'realmManager/getPasswordPolicy',
    realmManager_getRealm = 'realmManager/getRealm',
    realmManager_getSplashMessage = 'realmManager/getSplashMessage',
    realmManager_getSystemErrorsDownloadURL = 'realmManager/getSystemErrorsDownloadURL',
    realmManager_getSystemStorageDepot = 'realmManager/getSystemStorageDepot',
    realmManager_getTPAuthPasswordPolicy = 'realmManager/getTPAuthPasswordPolicy',
    realmManager_getVirusDefinitions = 'realmManager/getVirusDefinitions',
    realmManager_initializeOrganization = 'realmManager/initializeOrganization',
    realmManager_listAllTimezones = 'realmManager/listAllTimezones',
    realmManager_listConnectorStatusesForRealm = 'realmManager/listConnectorStatusesForRealm',
    realmManager_listConnectorDataAreaStatus = 'realmManager/listConnectorDataAreaStatus',
    realmManager_listCustomersForStorageFacility = 'realmManager/listCustomersForStorageFacility',
    realmManager_listDRTimezones = 'realmManager/listDRTimezones',
    realmManager_listDeletedProjects = 'realmManager/listDeletedProjects',
    realmManager_listJobs = 'realmManager/listJobs',
    realmManager_listLoggedInUsers = 'realmManager/listLoggedInUsers',
    realmManager_listNFSStorageAreas = 'realmManager/listNFSStorageAreas',
    realmManager_listNodes = 'realmManager/listNodes',
    realmManager_listProjectAccessRole = 'realmManager/listProjectAccessRole',
    realmManager_deleteNode = 'realmManager/deleteNode',
    realmManager_listOperationTypes = 'realmManager/listOperationTypes',
    realmManager_listOrganizationNames = 'realmManager/listOrganizationNames',
    realmManager_listOrganizations = 'realmManager/listOrganizations',
    realmManager_listProjects = 'realmManager/listProjects',
    realmManager_listRealmTasks = 'realmManager/listRealmTasks',
    realmManager_listRemoteNFSStorageAreas = 'realmManager/listRemoteNFSStorageAreas',
    realmManager_listServices = 'realmManager/listServices',
    realmManager_listSystemUserProjectsByUserName = 'realmManager/listSystemUserProjectsByUserName',
    realmManager_listSystemUserOrgs = 'realmManager/listSystemUserOrgs',
    realmManager_listProjectAccessHistory = 'realmManager/listProjectAccessHistory',
    realmManager_resetSessionInactivityTimeout = 'realmManager/resetSessionInactivityTimeout',
    realmManager_setSplashMessage = 'realmManager/setSplashMessage',
    realmManager_updateVirusDefinitions = 'realmManager/updateVirusDefinitions',
    realmManager_getInactivityTimeout = 'realmManager/getInactivityTimeout',
    realmManager_setPasswordPolicy = 'realmManager/setPasswordPolicy',
    realmManager_setInactivityTimeout = 'realmManager/setInactivityTimeout',
    realmManager_listEmailIdsToNotify = 'realmManager/listEmailIdsToNotify',
    realmManager_sendEmail = 'realmManager/sendEmail',
    realmManager_createMailServerConfig = 'realmManager/createMailServerConfig',
    realmManager_updateMailServerConfig = 'realmManager/updateMailServerConfig',
    realmManager_setEmailNotificationCfg = 'realmManager/setEmailNotificationCfg',
    realmManager_listDeletePendingProjects = 'realmManager/listDeletePendingProjects',
    realmManager_listSystemRoles = 'realmManager/listSystemRoles',
    realmManager_listImportedCustomerUsersByUserName = 'realmManager/listImportedCustomerUsersByUserName',
    realmManager_listImportedGroupsByGroupName = 'realmManager/listImportedGroupsByGroupName',
    realmManager_getStorageUsageDownloadUrl = 'realmManager/getStorageUsageDownloadUrl',
    realmManager_deleteOrganization = 'realmManager/deleteOrganization',
    realmManager_createService = 'realmManager/createService',
    realmManager_deleteService = 'realmManager/deleteService',
    realmManager_getAllOCRUsageStatistics = 'realmManager/getAllOCRUsageStatistics',
    realmManager_getOCRUsageStatisticsUrl = 'realmManager/getOCRUsageStatisticsUrl',
    realmManager_getOCRUsageStatistics = 'realmManager/getOCRUsageStatistics',
    realmManager_listMetadataBulkFields = 'realmManager/listMetadataBulkFields',
    realmManager_getDownloadProjectAccessHistoryUrl = 'realmManager/getDownloadProjectAccessHistoryUrl',
    realmManager_listSystemAuditLogs = 'realmManager/listSystemAuditLogs',
    realmManager_getDownloadSystemAuditLogUrl = 'realmManager/getDownloadSystemAuditLogUrl',
    // serviceManager
    serviceManager_listProjectsForService = 'serviceManager/listProjectsForService',
    serviceManager_updateService = 'serviceManager/updateService',
    // userManager
    userManager_getCurrentUser = 'userManager/getCurrentUser',
    userManager_getTPAuthUserInfo = 'userManager/getTPAuthUserInfo',
    userManager_changeUserPassword = 'userManager/changeUserPassword',
    userManager_createUserInTPAuth = 'userManager/createUserInTPAuth',
    userManager_isUserInTPAuth = 'userManager/isUserInTPAuth',
    userManager_logoutUser = 'userManager/logoutUser',
    userManager_updateUser = 'userManager/updateUser',
    userManager_validateUserName = 'userManager/validateUserName',
    userManager_resetPassword = 'userManager/resetPassword',
    userManager_getOrgUserbyName = 'userManager/getOrgUserbyName',
    userManager_validatePasswordForTPAuthPolicy = 'userManager/validatePasswordForTPAuthPolicy',
    userManager_acceptEula = 'userManager/acceptEula',
    userManager_assignUserToProjects = 'userManager/assignUserToProjects',
    // orgManager
    orgManager_assignGroupToProjects = 'orgManager/assignGroupToProjects',
    orgManager_copyRole = 'orgManager/copyRole',
    orgManager_createCIFSConnector = 'orgManager/createCIFSConnector',
    orgManager_createCorpus = 'orgManager/createCorpus',
    orgManager_createDataArea = 'orgManager/createDataArea',
    orgManager_createExchangeConnector = 'orgManager/createExchangeConnector',
    orgManager_createExportDatabaseConnection = 'orgManager/createExportDatabaseConnection',
    orgManager_createGoogleWorkspaceConnector = 'orgManager/createGoogleWorkspaceConnector',
    orgManager_createGroup = 'orgManager/createGroup',
    orgManager_createRealmNode = 'orgManager/createRealmNode',
    orgManager_createReviewSystemFolder = 'orgManager/createReviewSystemFolder',
    orgManager_createLotusNotesIdFile = 'orgManager/createLotusNotesIdFile',
    orgManager_createNFSConnector = 'orgManager/createNFSConnector',
    orgManager_createReefReviewConnector = 'orgManager/createReefReviewConnector',
    orgManager_createRole = 'orgManager/createRole',
    orgManager_createSharepointConnector = 'orgManager/createSharepointConnector',
    orgManager_createTemplate = 'orgManager/createTemplate',
    orgManager_createUser = 'orgManager/createUser',
    orgManager_deleteConnector = 'orgManager/deleteConnector',
    orgManager_deleteExportDatabaseConnection = 'orgManager/deleteExportDatabaseConnection',
    orgManager_deleteGroup = 'orgManager/deleteGroup',
    orgManager_deleteLotusNotesIdFile = 'orgManager/deleteLotusNotesIdFile',
    orgManager_deleteNFSDataArea = 'orgManager/deleteNFSDataArea',
    orgManager_deleteRole = 'orgManager/deleteRole',
    orgManager_deleteTemplate = 'orgManager/deleteTemplate',
    orgManager_deleteUser = 'orgManager/deleteUser',
    orgManager_exportProject = 'orgManager/exportProject',
    orgManager_exportTemplate = 'orgManager/exportTemplate',
    orgManager_getCase = 'orgManager/getCase',
    orgManager_getCifsMounts = 'orgManager/getCifsMounts',
    orgManager_getNfsMounts = 'orgManager/getNfsMounts',
    orgManager_getRole = 'orgManager/getRole',
    orgManager_getReefExpressSettings = 'orgManager/getReefExpressSettings',
    orgManager_importProject = 'orgManager/importProject',
    orgManager_importTemplate = 'orgManager/importTemplate',
    orgManager_listDataAreas = 'orgManager/listDataAreas',
    orgManager_listExportDataAreas = 'orgManager/listExportDataAreas',
    orgManager_listExportDatabaseConnections = 'orgManager/listExportDatabaseConnections',
    orgManager_listGroups = 'orgManager/listGroups',
    orgManager_listLdapDomains = 'orgManager/listLdapDomains',
    orgManager_listLotusNotesIdFiles = 'orgManager/listLotusNotesIdFiles',
    orgManager_listProjectDataAreas = 'orgManager/listProjectDataAreas',
    orgManager_listRoles = 'orgManager/listRoles',
    orgManager_listReviewSystemFolders = 'orgManager/listReviewSystemFolders',
    orgManager_listTemplates = 'orgManager/listTemplates',
    orgManager_listUsers = 'orgManager/listUsers',
    orgManager_listUsersAndGroups = 'orgManager/listUsersAndGroups',
    orgManager_listProjectsByUser = 'orgManager/listProjectsByUser',
    orgManager_listProjectsByGroup = 'orgManager/listProjectsByGroup',
    orgManager_listUserProjectsForAllOrgs = 'orgManager/listUserProjectsForAllOrgs',
    orgManager_requestProjectDelete = 'orgManager/requestProjectDelete',
    orgManager_setOrganizationDefaultRole = 'orgManager/setOrganizationDefaultRole',
    orgManager_setReefExpressSettings = 'orgManager/setReefExpressSettings',
    orgManager_unlockUser = 'orgManager/unlockUser',
    orgManager_enableDisableUser = 'orgManager/enableDisableUser',
    orgManager_updateExportDatabaseConnection = 'orgManager/updateExportDatabaseConnection',
    orgManager_updateGroup = 'orgManager/updateGroup',
    orgManager_updateLotusNotesIdFile = 'orgManager/updateLotusNotesIdFile',
    orgManager_updateProjectsState = 'orgManager/updateProjectsState',
    orgManager_updateRole = 'orgManager/updateRole',
    orgManager_updateTemplate = 'orgManager/updateTemplate',
    orgManager_validateExportDatabaseConnection = 'orgManager/validateExportDatabaseConnection',
    // groupManager
    groupManager_listUsers = 'groupManager/listUsers',
    groupManager_setUsers = 'groupManager/setUsers',
    groupManager_validateGroupName = 'groupManager/validateGroupName',
    // groupViewManager
    groupViewManager_compareToExport = 'groupViewManager/compareToExport',
    groupViewManager_exportUpdateProduction = 'groupViewManager/exportUpdateProduction',
    groupViewManager_exportView = 'groupViewManager/exportView',
    groupViewManager_exportViewLite = 'groupViewManager/exportViewLite',
    groupViewManager_previewExport = 'groupViewManager/previewExport',
    groupViewManager_produceDuplicatesVolume = 'groupViewManager/produceDuplicatesVolume',
    // ecaManager
    ecaManager_createCase = 'ecaManager/createCase',
    ecaManager_listCustodians = 'ecaManager/listCustodians',
    ecaManager_updateCustodian = 'ecaManager/updateCustodian',
    ecaManager_deleteBatch = 'ecaManager/deleteBatch',
    ecaManager_deleteCustodian = 'ecaManager/deleteCustodian',
    ecaManager_deleteMediaid = 'ecaManager/deleteMediaid',
    ecaManager_createCustodian = 'ecaManager/createCustodian',
    ecaManager_listExportStreams = 'ecaManager/listExportStreams',
    ecaManager_createExportStreamAndExport = 'ecaManager/createExportStreamAndExport',
    ecaManager_createExportStreamAndPreviewExport = 'ecaManager/createExportStreamAndPreviewExport',
    ecaManager_createEmptyExportStream = 'ecaManager/createEmptyExportStream',
    ecaManager_listBatches = 'ecaManager/listBatches',
    ecaManager_listMediaids = 'ecaManager/listMediaids',
    ecaManager_createBatch = 'ecaManager/createBatch',
    ecaManager_createMediaid = 'ecaManager/createMediaid',
    ecaManager_updateBatch = 'ecaManager/updateBatch',
    ecaManager_updateMediaid = 'ecaManager/updateMediaid',
    // projectManager
    projectManager_listReviewSystemImports = 'projectManager/listReviewSystemImports',
    projectManager_getDownloadReviewSystemImportErrorUrl = 'projectManager/getDownloadReviewSystemImportErrorUrl',
    projectManager_addToPasswordList = 'projectManager/addToPasswordList',
    projectManager_attachCorpusToProject = 'projectManager/attachCorpusToProject',
    projectManager_createActiveRule = 'projectManager/createActiveRule',
    projectManager_createAliasList = 'projectManager/createAliasList',
    projectManager_createDomain = 'projectManager/createDomain',
    projectManager_createEmailSignature = 'projectManager/createEmailSignature',
    projectManager_createExportMetadataProfile = 'projectManager/createExportMetadataProfile',
    projectManager_createFolder = 'projectManager/createDynamicFolder',
    projectManager_createRegex = 'projectManager/createRegex',
    projectManager_createTag = 'projectManager/createTag',
    projectManager_setSearchSettings = 'projectManager/setSearchSettings',
    projectManager_deleteActiveRule = 'projectManager/deleteActiveRule',
    projectManager_deleteAliasList = 'projectManager/deleteAliasList',
    projectManager_deleteDomain = 'projectManager/deleteDomain',
    projectManager_deleteDynamicFolder = 'projectManager/deleteDynamicFolder',
    projectManager_deleteEmailSignature = 'projectManager/deleteEmailSignature',
    projectManager_deleteExportMetadataProfile = 'projectManager/deleteExportMetadataProfile',
    projectManager_deleteFromPasswordList = 'projectManager/deleteFromPasswordList',
    projectManager_deleteLoadFileMetadataProfile = 'projectManager/deleteLoadFileMetadataProfile',
    projectManager_deleteRegex = 'projectManager/deleteRegex',
    projectManager_deleteTag = 'projectManager/deleteTag',
    projectManager_deleteTasks = 'projectManager/deleteTasks',
    projectManager_downloadPasswordDataUrl = 'projectManager/downloadPasswordDataUrl',
    projectManager_generateConsolidateBillingReport = 'projectManager/generateConsolidateBillingReport',
    projectManager_generateDownloadFromWorkbasketReport = 'projectManager/generateDownloadFromWorkbasketReport',
    projectManager_getAllSearchMetadataFields = 'projectManager/getAllSearchMetadataFields',
    projectManager_getAnalyticalSettings = 'projectManager/getAnalyticalSettings',
    projectManager_getCustomMetadataFieldsProfile = 'projectManager/getCustomMetadataFieldsProfile',
    projectManager_getDiscardPileLogDownloadUrl = 'projectManager/getDiscardPileLogDownloadUrl',
    projectManager_getDiscardPileLogs = 'projectManager/getDiscardPileLogs',
    projectManager_getDocumentMetadataTemplate = 'projectManager/getDocumentMetadataTemplate',
    projectManager_getDupeSurvivorshipSettings = 'projectManager/getDupeSurvivorshipSettings',
    projectManager_getEmailDeliveryPreference = 'projectManager/getEmailDeliveryPreference',
    projectManager_getExportMetadataProfile = 'projectManager/getExportMetadataProfile',
    projectManager_getExportOptions = 'projectManager/getExportOptions',
    projectManager_getExportOptionsForReview = 'projectManager/getExportOptionsForReview',
    projectManager_getIndexSettings = 'projectManager/getIndexSettings',
    projectManager_getLoadFileMetadataProfile = 'projectManager/getLoadFileMetadataProfile',
    projectManager_getLoadFileMetadataPrepareData = 'projectManager/getLoadFileMetadataPrepareData',
    projectManager_getMetadataValues = 'projectManager/getMetadataValues',
    projectManager_getPasswordList = 'projectManager/getPasswordList',
    projectManager_getPasswordSettings = 'projectManager/getPasswordSettings',
    projectManager_getPreference = 'projectManager/getPreference',
    projectManager_getProject = 'projectManager/getProject',
    projectManager_getProjectConfig = 'projectManager/getProjectConfig',
    projectManager_getProjectResourceStatus = 'projectManager/getProjectResourceStatus',
    projectManager_getReviewProjectFolderURL = 'projectManager/getReviewProjectFolderURL',
    projectManager_getReviewProjectList = 'projectManager/getReviewProjectList',
    projectManager_getReviewProjectTemplateList = 'projectManager/getReviewProjectTemplateList',
    projectManager_getSearchSettings = 'projectManager/getSearchSettings',
    projectManager_getTLSProjectConfiguration = 'projectManager/getTLSProjectConfiguration',
    projectManager_getUpdateStatus = 'projectManager/getUpdateStatus',
    projectManager_importPasswordList = 'projectManager/importPasswordList',
    projectManager_listAliasList = 'projectManager/listAliasList',
    projectManager_listBillingReportSettings = 'projectManager/listBillingReportSettings',
    projectManager_listCorpusSets = 'projectManager/listCorpusSets',
    projectManager_listDomainEntries = 'projectManager/listDomainEntries',
    projectManager_listDomains = 'projectManager/listDomains',
    projectManager_listDynamicFolders = 'projectManager/listDynamicFolders',
    projectManager_listExportMetadataProfile = 'projectManager/listExportMetadataProfile',
    projectManager_listLoadFileMetadataProfiles = 'projectManager/listLoadFileMetadataProfiles',
    projectManager_validateLoadFileMetadataProfileName = 'projectManager/validateLoadFileMetadataProfileName',
    projectManager_listMembers = 'projectManager/listMembers',
    projectManager_listRegexes = 'projectManager/listRegexes',
    projectManager_listSavedSearches = 'projectManager/listRuleBasedSavedSearches',
    projectManager_listSearchHistory = 'projectManager/listSearchHistory',
    projectManager_listSharedCorpora = 'projectManager/listSharedCorpora',
    projectManager_listTags = 'projectManager/listTags',
    projectManager_listTasks = 'projectManager/listTasks',
    projectManager_listWorkbasketUsers = 'projectManager/listWorkbasketUsers',
    projectManager_listWorkingSets = 'projectManager/listWorkingSets',
    projectManager_loadEmailSignatures = 'projectManager/listEmailSignatures',
    projectManager_projectGetSearchMetadataProfile = 'projectManager/projectGetSearchMetadataProfile',
    projectManager_projectSetSearchMetadataProfile = 'projectManager/projectSetSearchMetadataProfile',
    projectManager_processActiveRule = 'projectManager/processActiveRule',
    projectManager_removeCorpusFromProject = 'projectManager/removeCorpusFromProject',
    projectManager_removeDocumentsFromProject = 'projectManager/removeDocumentsFromProject',
    projectManager_removeSearchResultsFromProject = 'projectManager/removeSearchResultsFromProject',
    projectManager_restoreDefaultExportMetadataProfile = 'projectManager/restoreDefaultExportMetadataProfile',
    projectManager_restoreDocumentsToProject = 'projectManager/restoreDocumentsToProject',
    projectManager_restoreSearchResultsToProject = 'projectManager/restoreSearchResultsToProject',
    projectManager_retryUploadToReviewSystem = 'projectManager/retryUploadToReviewSystem',
    projectManager_setAnalyticalSettings = 'projectManager/setAnalyticalSettings',
    projectManager_setCustomMetadataFieldsProfile = 'projectManager/setCustomMetadataFieldsProfile',
    projectManager_setDocumentMetadataTemplate = 'projectManager/setDocumentMetadataTemplate',
    projectManager_setDupeSurvivorshipSettings = 'projectManager/setDupeSurvivorshipSettings',
    projectManager_setExportMetadataProfile = 'projectManager/setExportMetadataProfile',
    projectManager_setExportSettings = 'projectManager/setExportOptions',
    projectManager_setIndexSettings = 'projectManager/setIndexSettings',
    projectManager_setLoadFileMetadataProfile = 'projectManager/setLoadFileMetadataProfile',
    projectManager_setPasswordCrackingDictionary = 'projectManager/setPasswordCrackingDictionary',
    projectManager_setPasswordGoldenDictionary = 'projectManager/setPasswordGoldenDictionary',
    projectManager_setPasswordSettings = 'projectManager/setPasswordSettings',
    projectManager_setTLSProjectConfiguration = 'projectManager/setTLSProjectConfiguration ',
    projectManager_updateAliasList = 'projectManager/updateAliasList',
    projectManager_updateDomain = 'projectManager/updateDomain',
    projectManager_updateEmailSignature = 'projectManager/updateEmailSignature',
    projectManager_updateEmailDeliveryPreference = 'projectManager/updateEmailDeliveryPreference',
    projectManager_updatePreference = 'projectManager/updatePreference',
    projectManager_updateProject = 'projectManager/updateProject',
    projectManager_updateProjectService = 'projectManager/updateProjectService',
    projectManager_updateReviewProjectFolder = 'projectManager/updateReviewProjectFolder',
    projectManager_updateMultipleProjectsService = 'projectManager/updateMultipleProjectsService',
    projectManager_updateRegex = 'projectManager/updateRegex',
    projectManager_validateProjectName = 'projectManager/validateProjectName',
    projectManager_validateReviewProjectId = 'projectManager/validateReviewProjectId',
    projectManager_validateReviewUser = 'projectManager/validateReviewUser',
    projectManager_getReportSettings = 'projectManager/getReportSetting',
    projectManager_updateReportSettings = 'projectManager/updateReportSettings',
    projectManager_listProfiles = 'projectManager/listProfiles',
    projectManager_createProfile = 'projectManager/createProfile',
    projectManager_listComparisons = 'projectManager/listComparisons',
    projectManager_deleteProfile = 'projectManager/deleteProfile',
    projectManager_deleteComparison = 'projectManager/deleteComparison',
    projectManager_createComparison = 'projectManager/createComparison',
    projectManager_processComparisons = 'projectManager/processComparisons',
    projectManager_discoverLoadFile = 'projectManager/discoverLoadFile',
    projectManager_listAuditLogEvents = 'projectManager/listAuditLogEvents',
    projectManager_createAuditLogManifest = 'projectManager/createAuditLogManifest',
    projectManager_validateRegex = 'projectManager/validateRegex',
    projectManager_closeProject = 'projectManager/closeProject',
    projectManager_getCustomFields = 'projectManager/getCustomFields',
    // viewManager
    viewManager_addAllFamilyMembers = 'viewManager/addAllFamilyMembers',
    viewManager_addFromDocuments = 'viewManager/addFromDocuments',
    viewManager_addFromView = 'viewManager/addFromView',
    viewManager_bulkSearch = 'viewManager/bulkSearch',
    viewManager_createWordList = 'viewManager/createWordList',
    viewManager_exportErrorsMetaDataBulkSearch = 'viewManager/exportErrorsMetaDataBulkSearch',
    viewManager_exportManifest = 'viewManager/exportViewManifest',
    viewManager_exportWordListManifestFile = 'viewManager/exportWordListManifestFile',
    viewManager_getReport = 'viewManager/getReport',
    viewManager_getValidateBulkSearchResult = 'viewManager/getValidateBulkSearchResult',
    viewManager_getViewBreadcrumbHistory = 'viewManager/getViewBreadcrumbHistory',
    viewManager_getWordListPage = 'viewManager/getWordListPage',
    viewManager_listBulkSearchChildViews = 'viewManager/listBulkSearchChildViews',
    viewManager_listDocuments = 'viewManager/listDocuments',
    viewManager_metaDataBulkSearch = 'viewManager/metaDataBulkSearch',
    viewManager_removeFromDocuments = 'viewManager/removeFromDocuments',
    viewManager_removeFromEmailThreads = 'viewManager/removeFromEmailThreads',
    viewManager_removeFromView = 'viewManager/removeFromView',
    viewManager_retrieveManifest = 'viewManager/retrieveManifest',
    viewManager_retrieveManifestURL = 'viewManager/retrieveViewManifestUrl',
    viewManager_retrieveReport = 'viewManager/retrieveReport',
    viewManager_search = 'viewManager/search',
    viewManager_tagDocuments = 'viewManager/tagDocuments',
    viewManager_tagViews = 'viewManager/tagViews',
    viewManager_updateActiveRule = 'viewManager/updateActiveRule',
    viewManager_updateView = 'viewManager/updateView',
    viewManager_validateName = 'viewManager/validateName',
    viewManager_getDocumentInfo = 'viewManager/getDocumentInfo',
    viewManager_getView = 'viewManager/getView',
    viewManager_getDocumentHistory = 'viewManager/getDocumentHistory',
    viewManager_getDocumentAttachments = 'viewManager/getDocumentAttachments',
    viewManager_validateBulkSearch = 'viewManager/validateBulkSearch',
    viewManager_searchByDoc = 'viewManager/searchByDoc',
    viewManager_getMetadataProperties = 'viewManager/getMetadataProperties',
    viewManager_canReprocess = 'viewManager/canReprocess',
    viewManager_canReprocessResult = 'viewManager/canReprocessResult',
    viewManager_searchByView = 'viewManager/searchByView',
    viewManager_searchByDocuments = 'viewManager/searchByDocuments',
    viewManager_searchForDuplicateDocuments = 'viewManager/searchForDuplicateDocuments',
    viewManager_searchForDuplicateGroups = 'viewManager/searchForDuplicateGroups',
    viewManager_createSampleSet = 'viewManager/createSampleSet',
    viewManager_tagEmailThread = 'viewManager/tagEmailThread',
    viewManager_addFromEmailThread = 'viewManager/addFromEmailThread',
    viewManager_listExportViewUpdateDates = 'viewManager/listExportViewUpdateDates',
    viewManager_createExportViewManifest = 'viewManager/createExportViewManifest',
    viewManager_drillDownOnReport = 'viewManager/drillDownOnReport',
    viewManager_filterReviewFolderReport = 'viewManager/filterReviewFolderReport',
    viewManager_invalidateReportCache = 'viewManager/invalidateReportCache',
    viewManager_canUpdateMetadata = 'viewManager/canUpdateMetadata',
    viewManager_canUpdateMetadataResult = 'viewManager/canUpdateMetadataResult',
    viewManager_validateQueries = 'viewManager/validateQueries',
    // connectorManager
    connectorManager_createReviewConnectors = 'connectorManager/createReviewConnectors',
    connectorManager_exploreConnector = 'connectorManager/exploreConnector',
    connectorManager_getCIFSConnector = 'connectorManager/getCIFSConnector',
    connectorManager_getConnector = 'connectorManager/getConnector',
    connectorManager_getGoogleWorkspaceConnector = 'connectorManager/getGoogleWorkspaceConnector',
    connectorManager_getNFSConnector = 'connectorManager/getNFSConnector',
    connectorManager_getSharepointConnector = 'connectorManager/getSharepointConnector',
    connectorManager_getExchangeConnector = 'connectorManager/getExchangeConnector',
    connectorManager_getReviewConnectors = 'connectorManager/getReviewConnectors',
    connectorManager_previewCustodians = 'connectorManager/previewCustodians',
    connectorManager_previewMediaIds = 'connectorManager/previewMediaIds',
    connectorManager_updateCIFSConnector = 'connectorManager/updateCIFSConnector',
    connectorManager_updateGoogleWorkspaceConnector = 'connectorManager/updateGoogleWorkspaceConnector',
    connectorManager_updateNFSConnector = 'connectorManager/updateNFSConnector',
    connectorManager_updateSharepointConnector = 'connectorManager/updateSharepointConnector',
    connectorManager_validateCIFSConnector = 'connectorManager/validateCIFSConnector',
    connectorManager_validateGoogleWorkspaceConnector = 'connectorManager/validateGoogleWorkspaceConnector',
    connectorManager_validateNFSConnector = 'connectorManager/validateNFSConnector',
    connectorManager_validateSharepointConnector = 'connectorManager/validateSharepointConnector',
    connectorManager_updateExchangeConnector = 'connectorManager/updateExchangeConnector',
    connectorManager_validateExchangeConnector = 'connectorManager/validateExchangeConnector',
    connectorManager_updateReviewConnectors = 'connectorManager/updateReviewConnectors',
    connectorManager_validateReviewConnector = 'connectorManager/validateReviewConnector',
    // taskManager
    taskManager_applyBulkJobPriorityUpdate = 'taskManager/applyBulkJobPriorityUpdate',
    taskManager_cancelTask = 'taskManager/cancelTask',
    taskManager_getSRITaskLog = 'taskManager/getSRITaskLog',
    taskManager_getTasks = 'taskManager/getTasks',
    taskManager_pauseTask = 'taskManager/pauseTask',
    taskManager_resumeTask = 'taskManager/resumeTask',
    taskManager_updateJobPriority = 'taskManager/updateJobPriority',
    // corpusSetManager
    corpusSetManager_addCorpus = 'corpusSetManager/addCorpus',
    corpusSetManager_getCorpusSetByName = 'corpusSetManager/getCorpusSetByName',
    corpusSetManager_listCorporaInCorpusSet = 'corpusSetManager/listCorporaInCorpusSet',
    // corpusManager
    corpusManager_copyToDocStorage = 'corpusManager/copyToDocStorage',
    corpusManager_copyDocsToLocation = 'corpusManager/copyDocsToLocation',
    corpusManager_createRepresentation = 'corpusManager/createRepresentation',
    corpusManager_extractExternalDataFromView = 'corpusManager/extractExternalDataFromView',
    corpusManager_extractExternalDataFromDocuments = 'corpusManager/extractExternalDataFromDocuments',
    corpusManager_getImportExceptionsUrl = 'corpusManager/getImportExceptionsUrl',
    corpusManager_getRepresentationConfig = 'corpusManager/getRepresentationConfig',
    corpusManager_listImportExceptions = 'corpusManager/listImportExceptions',
    corpusManager_listScanHistoryEvents = 'corpusManager/listScanHistoryEvents',
    corpusManager_ocrFromDocuments = 'corpusManager/ocrFromDocuments',
    corpusManager_ocrFromView = 'corpusManager/ocrFromView',
    corpusManager_purgeFromDocuments = 'corpusManager/purgeFromDocuments',
    corpusManager_purgeFromView = 'corpusManager/purgeFromView',
    corpusManager_reprocessFromView = 'corpusManager/reprocessFromView',
    corpusManager_reprocessFromDocuments = 'corpusManager/reprocessFromDocuments',
    corpusManager_updateCorpusData = 'corpusManager/updateCorpusData',
    corpusManager_updateMetadataForDocuments = 'corpusManager/updateMetadataForDocuments',
    corpusManager_updateMetadataForViewDocuments = 'corpusManager/updateMetadataForViewDocuments',
    // adminOrgManager
    adminOrgManager_approveProjectDeleteRequest = 'adminOrgManager/approveProjectDeleteRequest',
    adminOrgManager_deactivateConnectors = 'adminOrgManager/deactivateConnectors',
    adminOrgManager_declineProjectDeleteRequest = 'adminOrgManager/declineProjectDeleteRequest',
    adminOrgManager_listConnectors = 'adminOrgManager/listConnectors',
    adminOrgManager_listRoles = 'adminOrgManager/listRoles',
    adminOrgManager_listUsersAndGroups = 'adminOrgManager/listUsersAndGroups',
    adminOrgManager_requestProjectDelete = 'adminOrgManager/requestProjectDelete',
    adminOrgManager_createGroup = 'adminOrgManager/createGroup',
    adminOrgManager_createRealmNode = 'adminOrgManager/createRealmNode',
    adminOrgManager_createUser = 'adminOrgManager/createUser',
    adminOrgManager_deleteUser = 'adminOrgManager/deleteUser',
    adminOrgManager_addSystemUserToOrg = 'adminOrgManager/addSystemUserToOrg',
    adminOrgManager_addSystemGroupToOrg = 'adminOrgManager/addSystemGroupToOrg',
    adminOrgManager_setSystemMemberToOrg = 'adminOrgManager/setSystemMemberToOrg',
    adminOrgManager_updateOrganization = 'adminOrgManager/updateOrganization',
    adminOrgManager_removeSystemUsersFromOrganization = 'adminOrgManager/removeSystemUsersFromOrganization',
    adminOrgManager_updateSystemGroupRoles = 'adminOrgManager/updateSystemGroupRoles',
    adminOrgManager_updateSystemUsersRoles = 'adminOrgManager/updateSystemUsersRoles',
    // permissionManager
    permissionManager_getCombinedUserRole = 'permissionManager/getCombinedUserRole',
    permissionManager_getPermission = 'permissionManager/getPermission',
    permissionManager_setPermission = 'permissionManager/setPermission',
    permissionManager_getSecureObjectGroups = 'permissionManager/getSecureObjectGroups',
    // keyboardShortcutManager
    keyboardShortcutManager_isKeyboardShortcutsEnabled = 'keyboardShortcutManager/isKeyboardShortcutsEnabled',
    // templateManager
    templateManager_copyMetaTemplateProfileEntriesToOrganizations = 'templateManager/copyMetaTemplateProfileEntriesToOrganizations',
    templateManager_copyToTemplate = 'templateManager/copyToTemplate',
    templateManager_copyFromTemplate = 'templateManager/copyFromTemplate',
    templateManager_getMetaTemplateProfileEntries = 'templateManager/getMetaTemplateProfileEntries',
    templateManager_updateMetaTemplateProfileEntries = 'templateManager/updateMetaTemplateProfileEntries',
    templateManager_importTemplates = 'templateManager/importTemplates',
    templateManager_exportTemplates = 'templateManager/exportTemplates',
    // dataAreaManager
    dataAreaManager_updateDataArea = 'dataAreaManager/updateDataArea',
    dataAreaManager_validateDataArea = 'dataAreaManager/validateDataArea',
    dataAreaManager_validateDataAreaName = 'dataAreaManager/validateDataAreaName',
    dataAreaManager_getDataAreaByReviewProject = 'dataAreaManager/getDataAreaByReviewProject',
    // tagManager
    tagManager_updateTag = 'tagManager/updateTag',
    // dynamicFolderManager
    dynamicFolderManager_updateDynamicFolder = 'dynamicFolderManager/updateDynamicFolder',
    // workFlowManager
    workFlowManager_createWorkFlow = 'workFlowManager/createWorkFlow',
    workFlowManager_copyWorkFlow = 'workFlowManager/copyWorkFlow',
    workFlowManager_deleteWorkFlow = 'workFlowManager/deleteWorkFlow',
    workflowManager_deleteWorkflowFromTemplate = "workFlowManager/deleteWorkflowFromTemplate",
    workFlowManager_getWorkFlow = 'workFlowManager/getWorkFlow',
    workFlowManager_getWorkFlows = 'workFlowManager/getWorkFlows',
    workFlowManager_lockWorkFlow = 'workFlowManager/lockWorkFlow',
    workFlowManager_processWorkFlow = 'workFlowManager/processWorkFlow',
    workFlowManager_unlockWorkFlow = 'workFlowManager/unlockWorkFlow',
    workFlowManager_updateWorkFlow = 'workFlowManager/updateWorkFlow',
    workFlowManager_validateWorkFlow = 'workFlowManager/validateWorkFlow',
    workFlowManager_validateWorkFlowResult = 'workFlowManager/validateWorkFlowResult',
    workFlowManager_listWorkFlows = 'workFlowManager/listWorkFlows',
    workFlowManager_loadWorkflowFromTemplate = 'workFlowManager/loadWorkflowFromTemplate',
    workFlowManager_saveWorkflowToTemplate = 'workFlowManager/saveWorkflowToTemplate',
    workFlowManager_addReportToWorkFlow = 'workFlowManager/addReportToWorkFlow',
    // workingSetManager
    workingSetManager_listWorkingSetViews = 'workingSetManager/listWorkingSetViews',
    workingSetManager_deleteView = 'workingSetManager/deleteView',
    workingSetManager_createClusterView = 'workingSetManager/createClusterView',
    workingSetManager_createClusterViewResult = 'workingSetManager/createClusterViewResult',
    workingSetManager_importBaselineImageLoadFile = 'workingSetManager/importBaselineImageLoadFile',
    workingSetManager_listExportStreams = 'workingSetManager/listExportStreams',
    workingSetManager_listWorkingSetCorpora = 'workingSetManager/listWorkingSetCorpora',
    workingSetManager_getDefaultExportStreamOptions = "workingSetManager/getDefaultExportStreamOptions",
    // workingSetViewManager
    workingSetViewManager_listEmailsInThread = 'workingSetViewManager/listEmailsInThread',
    workingSetViewManager_listEmailsInThreadResult = 'workingSetViewManager/listEmailsInThreadResult',
    workingSetViewManager_listEmailThreads = 'workingSetViewManager/listEmailThreads',
    workingSetViewManager_listEmailThreadsResult = 'workingSetViewManager/listEmailThreadsResult',
    workingSetViewManager_threadEmails = 'workingSetViewManager/threadEmails',
    workingSetViewManager_unthreadEmails = 'workingSetViewManager/unthreadEmails',
    // documentManager
    documentManager_retrieveDocument = 'documentManager/retrieveDocument',
    documentManager_retrieveDocuments = 'documentManager/retrieveDocuments',
    // Profile Manager
    profileManager_updateProfile = 'profileManager/updateProfile',
    profileManager_setContent = 'profileManager/setContent',
    profileManager_getProfile = 'profileManager/getProfile',
    profileManager_listProfileHistories = 'profileManager/listProfileHistories',
    // clusterViewManager
    clusterViewManager_listChildViews = 'clusterViewManager/listChildViews',
    clusterViewManager_cluster = 'clusterViewManager/cluster',
    clusterViewManager_generateClusterReport = 'clusterViewManager/generateClusterReport',
    clusterViewManager_uncluster = 'clusterViewManager/uncluster',
    clusterViewManager_updateCluster = 'clusterViewManager/updateCluster',
    // billingReportManager
    billingReportManager_updateBillingReportSettings = 'billingReportManager/updateBillingReportSettings',
    // comparisonManager
    comparisonManager_updateComparison = 'comparisonManager/updateComparison',
    comparisonManager_processComparison = 'comparisonManager/processComparison',
    // exportStreamManager
    exportStreamManager_exportStream = 'exportStreamManager/exportStream',
    exportStreamManager_exportStreamNearDuplicate = 'exportStreamManager/exportStreamNearDuplicate',
    exportStreamManager_getExportStream = 'exportStreamManager/getExportStream',
    exportStreamManager_listExportVolumes = 'exportStreamManager/listExportVolumes',
    exportStreamManager_updateExportStream = 'exportStreamManager/updateExportStream',
    exportStreamManager_updateExportStreamCustodians = 'exportStreamManager/updateExportStreamCustodians',
    exportStreamManager_updateExportVolume = 'exportStreamManager/updateExportVolume',
    //storageAreaManager
    storageAreaManager_countCustomersForFacility = 'storageAreaManager/countCustomersForFacility',
    storageAreaManager_listOrganizationStorageAreas = 'storageAreaManager/listOrganizationStorageAreas',
    storageAreaManager_listOrganizationStorageInfo = 'storageAreaManager/listOrganizationStorageInfo',
    storageAreaManager_updateRemoteNFSStorageArea = 'storageAreaManager/updateRemoteNFSStorageArea',
    storageAreaManager_updateStorageFacilityUseCriteria = 'storageAreaManager/updateStorageFacilityUseCriteria',
}

export enum FilterAttribute {
    COMPLETETIME = 'COMPLETETIME',
    DESCRIPTION = 'DESCRIPTION',
    docBasedResultsOnly = 'docBasedResultsOnly',
    filteronowner = 'filteronowner',
    OWNER = 'OWNER',
    STARTTIME = 'STARTTIME',
    STATUS = 'STATUS',
    WORKBASKET_COUNT = 'WORKBASKET_COUNT',
    PASSWORD = 'PASSWORD',
    NAME = 'name',
    ERROREXIST = 'ERROREXIST',
    SYNTAXERROR = 'SYNTAXERROR',
    OPERATIONSTATE = 'OPERATIONSTATE'
}

export enum FilterOperator {
    EQUALS = 'EQUALS',
    BEFORE = 'BEFORE',
    AFTER = 'AFTER',
    LESS_THAN = 'LESS_THAN',
    GREATER_THAN = 'GREATER_THAN',
    LIKE = 'LIKE',
    NOT = 'NOT'
}

export enum OrganizationUpdateStatusType {
    PROJECT,
    ADMIN_REQUEST
}

export enum UpdateStatusType {
    ACTIVE_RULE = 'ACTIVE_RULE',
    ADMIN_REQUEST = 'ADMIN_REQUEST',
    ALIAS_LISTS = 'ALIAS_LISTS',
    BATCH = 'BATCH',
    BULKSEARCH_IN_SEARCH_HISTORY = 'BULKSEARCH_IN_SEARCH_HISTORY',
    CLUSTER_VIEW = 'CLUSTER_VIEW',
    COMPARISON = 'COMPARISON',
    COMPONENT = 'COMPONENT',
    CONNECTOR = 'CONNECTOR',
    CORPUS = 'CORPUS',
    CORPUS_MEMBERSHIP = 'CORPUS_MEMBERSHIP',
    CORPUS_SET = 'CORPUS_SET',
    CORPUS_SET_MEMBERSHIP = 'CORPUS_SET_MEMBERSHIP',
    CUSTODIAN = 'CUSTODIAN',
    CUSTOM_FIELD = 'CUSTOM_FIELD',
    DATA_AREA = 'DATAAREA',
    DOCUMENT_CODED = 'DOCUMENT_CODED',
    DOMAIN_MEMBERSHIP = 'DOMAIN_MEMBERSHIP',
    DYNAMIC_FOLDER_VIEW = 'DYNAMIC_FOLDER_VIEW',
    EMAIL_THREADING_STATE = 'EMAIL_THREADING_STATE',
    EXCLUDED_CONTENT = 'EXCLUDED_CONTENT',
    EXPORT_DATABASE = 'EXPORT_DATABASE',
    EXPORT_VIEW = 'EXPORT_VIEW',
    GROUP_VIEW = 'GROUP_VIEW',
    REALM_NODE_VIEW = 'REALM_NODE_VIEW',
    IMPORT_PROJECT = 'IMPORT_PROJECT',
    KEY_FILE = 'KEY_FILE',
    MEDIAID = 'MEDIAID',
    MODEL = 'MODEL',
    NON_CUSTODIAN = 'NON_CUSTODIAN',
    ORGANIZATION = 'ORGANIZATION',
    PATTERN = 'PATTERN',
    PROFILE = 'PROFILE',
    PROJECT = 'PROJECT',
    PROJECT_SETTING = 'PROJECT_SETTING',
    RESULT_MEMBERSHIP = 'RESULT_MEMBERSHIP',
    RESULT_VIEW = 'RESULT_VIEW',
    REVIEW_BATCH = 'REVIEW_BATCH',
    REVIEW_BATCH_FOLDER = 'REVIEW_BATCH_FOLDER',
    SAMPLE_SET = 'SAMPLE_SET',
    SAVED_SEARCH = 'SAVED_SEARCH',
    SEARCH = 'SEARCH',
    STORAGE = 'STORAGE',
    SYSTEM_ERRORS = 'SYSTEM_ERRORS',
    TAG_VIEW = 'TAG_VIEW',
    TASK = 'TASK',
    TEMPLATE_MEMEBERSHIP = 'TEMPLATE_MEMEBERSHIP',
    USER = 'USER',
    USER_PASSWORD = 'USER_PASSWORD',
    VIEW = 'VIEW',
    VIEW_MEMBERSHIP = 'VIEW_MEMBERSHIP',
    WORK_FLOW = 'WORK_FLOW',
    WORKING_SET = 'WORKING_SET',
    WORKING_SET_MEMBERSHIP = 'WORKING_SET_MEMBERSHIP',
    WORKING_SET_VIEW = 'WORKING_SET_VIEW',
    SERVICE = 'SERVICE',
}

export enum EntityType {
    import = 'import',
    export = 'export',
    exportVolume = 'exportVolume',
    projectData = 'projectData',
    custodian = 'custodian',
    mediaID = 'mediaID',
    batch = 'Batch',
    tagView = 'tagView',
    folder = 'folder',
    projectDataExport = 'projectDataExport',
    discardPile = 'discardPile',
    savedSearch = 'savedSearch',
    searchResult = 'searchResult',
    searchResultImport = 'searchResultImport',
    similaritySearchResult = 'similaritySearchResult',
    exactOrContentDuplicatesSearchResult = 'exactOrContentDuplicatesSearchResult',
    workFlow = 'workFlow',
    comparison = 'comparison',
    profile = 'profile',
    profileHistory = 'profileHistory',
    reviewSet = 'reviewSet',
    reviewProduction = 'reviewProduction',
    reviewFolder = 'reviewFolder',
    reviewBatch = 'reviewBatch',
    clusterView = 'clusterView',
    cluster = 'cluster',
    emailThread = 'emailThread',
    shortMessageThread = 'shortMessageThread',
    shortMessageThreadDocList = 'shortMessageThreadDocList',
    exceptionView = 'exceptionView',
    sampleSet = 'sampleSet',
    searchHistory = 'searchHistory',
    analytics = 'analytics',
    searchResultExportErrors = 'searchResultExportErrors',
    searchResultDiscardPile = 'searchResultDiscardPile'
}

export enum MessageType {
    entityChanged = 'entityChanged',
    logOut = 'logOut',
    sessionExpired = 'sessionExpired',
    project = 'project',
    dataArea = 'dataArea',
    refreshBulkSearchParentNode = 'refreshBulkSearchParentNode',
    refreshCluster = 'refreshCluster',
    refreshLeftTreeNodes = 'refreshLeftTreeNodes',
    refreshTreeNodesWithLoadingInProgress = 'refreshTreeNodesWithLoadingInProgress',
    reloadExceptionDetailsListAfterPollComplete = 'reloadExceptionDetailsListAfterPollComplete',
    removeRestoreDocs = 'removeRestoreDocs',
    navigationRequest = 'navigationRequest',
    currentColumns = 'currentColumns',
    tabNavigationRequest = 'tabNavigationRequest',
    updateProjectMonitoringStatus = 'updateProjectMonitoringStatus',
    clearPendingNavigation = 'clearPendingNavigation',
    closeDocumentViewer = 'closeDocumentViewer',
    cancelBulkSearch = 'cancelBulkSearch',
    outsideScrollClick = 'outsideScrollClick',
    stopPollingOnActiveUserSessions = 'stopPollingOnActiveUserSessions',
    fieldInFocus = 'fieldInFocus',
    fieldsUpdated = 'fieldsUpdated',
    closeAllDatePickers = 'closeAllDatePickers',
    gridHeadersChanged = 'gridHeadersChanged',
    filterGridHeadersChanged = 'filterGridHeadersChanged',
    updateSystemSettingsProjectList = 'updateSystemSettingsProjectList',
    updatePermissions = 'updatePermissions',
    generateDocList = 'generateDocList',
    undoLastSelection = 'undoLastSelection',
    updateSystemSettingsOrganizationList = 'updateSystemSettingsOrganizationList',
    organization = 'organization',
    isNewExport = 'isNewExport',
    getMetadataValuesAfterPollComplete = 'getMetadataValuesAfterPollComplete',
    updateStoragesList = 'updateStoragesList',
    connectorChanged = 'connectorChanged',
    loadFilePathChanged = 'loadFilePathChanged',
    enableReportDownload = 'enableReportDownload'
}

export enum MessageModalType {
    error = 'Error',
    success = 'Success',
    warning = 'Warning',
    information = 'Information',
    confirmation = 'Confirmation',
    confirmationInfo = 'ConfirmationInfo',
    confirmationDelete = 'ConfirmationDelete'
}

export enum UsersAndGroupsMembershipActionType {
    addToRemoveFromProjects = 'addToRemoveFromProjects',
    addToRemoveFromOrganizations = 'addToRemoveFromOrganizations'
}

export enum TemplateOperationType {
    saveAs = 'saveAs',
    loadFrom = 'loadFrom'
}

export enum TagOperationType {
    tag = 'tag',
    untag = 'untag',
    select = 'select',
    selectTagStateList = 'selectTagStateList',
}

export enum TagScope {
    DOCUMENT_ONLY = 'DOCUMENT_ONLY',
    MESSAGE_ATTACHMENT_GROUP = 'MESSAGE_ATTACHMENT_GROUP',
    EMAIL_THREAD = 'EMAIL_THREAD'
}

export enum TagState {
    NONE = 'NONE',
    ON = 'ON'
}

export enum ToastNotificationType {
    success = 'success',
    error = 'error',
    warning = 'warning',
    information = 'information'
}

export enum EntryType {
    aliases = 'Aliases',
    domainEntries = 'DomainEntries'
}

export enum SearchType {
    FREEFORM = 'VECTOR_SET_SEARCH',
    // QUERYBUILDER,  Not in this release
    ADVANCED = 'ADVANCED', // TODO: What should this actually be?
    BULK = 'BULK_SEARCH',
    METADATA_BULK = 'METADATA_BULK_SEARCH',
    COLLECTION_SIMILARITY = 'COLLECTION_SIMILARITY',
    VECTOR_SET_FIND_DUPLICATES = 'VECTOR_SET_FIND_DUPLICATES',
    DOCUMENT_FIND_DUPLICATES = 'DOCUMENT_FIND_DUPLICATES',
    SEARCH_FROM_BULK_SEARCH = 'SEARCH_FROM_BULK_SEARCH',
}

export enum StorageType {
    Document = 'Document',
    Index = 'Index'
}

export enum SettingsType {
    system = 'system',
    project = 'project',
    organization = 'organization'
}

export enum StatusType {
    status = 'status',
}

export enum PatternOperationType {
    new_pattern = 'new_pattern',
    edit_system_pattern = 'edit_system_pattern',
    edit_custom_pattern = 'edit_custom_pattern',
    copy_pattern = 'copy_pattern'
}

export enum ExcludedContentOperationType {
    new_excluded_content_block = 'new_excluded_content_block',
    edit_excluded_content_block = 'edit_excluded_content_block',
    duplicate_excluded_content_block = 'duplicate_excluded_content_block'
}

export enum ModalTargetType {
    bulk = 'bulk',
    document = 'document',
    emailThread = 'emailThread',
    report = 'report',
    selection = 'selection',
    view = 'view'
}

export enum SaveToRemoveFromOperationType {
    add = 'add',
    remove = 'remove'
}

export enum RemoveRestoreDocsOperationType {
    removeFromProjectData = 'removeFromProjectData',
    sendToDiscardPile = 'sendToDiscardPile',
    restoreFromDiscardPile = 'restoreFromDiscardPile',
    deleteFilesFromProject = 'deleteFilesFromProject'
}

export enum OperationType {
    edit = 'Edit',
    new = 'New'
}

export enum ConnectorType {
    NFS = 'NFS',
    CIFS = 'CIFS',
    MSExchange = 'Exchange',
    MSSharePoint = 'MSSharePoint',
    GoogleWorkspace = 'GoogleWorkspace'
}

export enum SearchDialect {
    DR_CLASSIC = 'DR_CLASSIC',
    STANDARD = 'STANDARD'
}

export enum DataAreaType {
    PROJECT,
    EXPORT
}

export enum FileSizeUnit {
    KB = 'KILOBYTES',
    MB = 'MEGABYTES',
    GB = 'GIGABYTES',
    TB = 'TERABYTES'
}

export enum ExternalAreaModalType {
    copyTo,
    copyFor,
    loadFrom,
    importExternal
}

export enum ClusterModalType {
    Build = 'Build Clusters',
    Rebuild = 'Rebuild Clusters',
    Generate = 'Generate Cluster Report',
    Subclusters = 'Build Subclusters',
}

export enum TransformerType {
    none = 'LoadFilePassThroughFieldTransformerType',
    text = 'LoadFileTextDataFieldTransformerType',
    date = 'LoadFileDateFieldTransformerType',
    number = 'Unknown'
}

export enum TextOperations {
    concat = 'Concatenate',
    replace = 'Replace',
    prefix = 'Prefix',
    suffix = 'Suffix',
    lowercase = 'Lower Case',
    uppercase = 'Upper Case',
    ltrim = 'Left Trim',
    rtrim = 'Right Trim'
}

export enum DocumentListTabType {
    history = 'history',
    family = 'family',
    thread = 'thread',
    docList = 'docList',
    exception = 'exception'
}

export enum SearchTypeIconFirstLetter {
    DRAdvancedSearch = 'A',
    DRSimpleSearch = 'F',
    DRQuickSearch = 'F',
    docList = 'docList'
}

export enum SizeUnits {
    BYTES = 'BYTES',
    KILOBYTES = 'KILOBYTES',
    MEGABYTES = 'MEGABYTES',
    GIGABYTES = 'GIGABYTES'
}

export enum DrWsRequestMessageStatus {
    SUCCESS = 'SUCCESS',
    PAUSED = 'PAUSED',
    FAILURE = 'FAILURE',
    UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export enum MetadataTokenizationType {
    untokenized = 'untokenized',
    lowercase_untokenized = 'lowercase_untokenized',
    standard = 'standard',
    standard_with_wildcard = 'standard_with_wildcard',
    path = 'path',
    icu_rules = 'icu_rules'
}

export enum PasswordListType {
    FOUND_PASSWORDS = 'FOUND_PASSWORDS',
    KNOWN_PASSWORDS = 'KNOWN_PASSWORDS',
    FREQUENTLY_USED_PASSWORDS = 'FREQUENTLY_USED_PASSWORDS'
}

export enum ConflictResolutionType {
    COPY = 'COPY',
    OVERWRITE = 'OVERWRITE'
}

export enum PasswordSourceType {
    MANUAL = 'Manual',
    FOUND_PASSWORDS = 'Found Passwords',
    FILE = 'File',
    IMPORT = 'Import'
}

export enum PasswordListOperationType {
    ADD_FILE = 'ADD_FILE',
    DELETE = 'DELETE',
    ADD_MANUAL = 'ADD_MANUAL',
    IMPORT = 'IMPORT'
}

export enum LocalStorageKey {
    AppForcedReload = 'appForcedReload',
    RememberMeWithToken = 'DRTokenCredentials',
    Uuid = '_uid',
    AppContext = 'AppContext',
    IsTpAuthRedirect = 'IsTpAuthRedirect',
    TpAuthSessionToken = 'sessionToken',
    TpAuthLoginError = 'loginError'
}

export enum ErrorCode {
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    NON_UNIQUE_ARGUMENT = "NON_UNIQUE_ARGUMENT",
    THRESHOLD_NOT_SATISFIED = "THRESHOLD_NOT_SATISFIED",
    COLLECTION_NOT_FOUND = "COLLECTION_NOT_FOUND",
    COLLECTION_WRONG_TYPE = "COLLECTION_WRONG_TYPE",
    COLLECTION_BUSY = "COLLECTION_BUSY",
    PROJECT_NOT_ACTIVATED = "PROJECT_NOT_ACTIVATED",
    DOCUMENT_NOT_FOUND = "DOCUMENT_NOT_FOUND",
    CAE_ERROR = "CAE_ERROR",
    CAE_TIMEOUT = "CAE_TIMEOUT",
    CAE_CANCEL = "CAE_CANCEL",
    PERMISSION_DENIED = "PERMISSION_DENIED",
    WORKBASKET_NOT_FOUND = "WORKBASKET_NOT_FOUND",
    WORKBASKET_WRONG_STATE = "WORKBASKET_WRONG_STATE",
    COLLECTION_EMPTY = "COLLECTION_EMPTY",
    COLLECTION_NOT_READY = "COLLECTION_NOT_READY",
    CSM_REBOOT = "CSM_REBOOT",
    REGEX_NOT_FOUND = "REGEX_NOT_FOUND",
    PROJECT_DOWN = "PROJECT_DOWN",
    OUT_OF_DISK_SPACE = "OUT_OF_DISK_SPACE",
    PROJECT_CONFIG_NOT_FOUND = "PROJECT_CONFIG_NOT_FOUND",
    ORGANIZATION_CONFIG_NOT_FOUND = "ORGANIZATION_CONFIG_NOT_FOUND",
    CONCURRENT_MODIFICATION = "CONCURRENT_MODIFICATION",
    TAG_NOT_FOUND = "TAG_NOT_FOUND",
    DATA_AREA_UNAVAILABLE = "DATA_AREA_UNAVAILABLE",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    TAG_ALREADY_EXISTS = "TAG_ALREADY_EXISTS",
    TAG_OPERATION_NOT_PERMITTED = "TAG_OPERATION_NOT_PERMITTED",
    INCORRECT_BATCH_NUMBER = "INCORRECT_BATCH_NUMBER",
    WORKBASKET_RESULTS_INVALID = "WORKBASKET_RESULTS_INVALID",
    LICENSE_VIOLATED = "LICENSE_VIOLATED",
    CORPUS_NOT_FOUND = "CORPUS_NOT_FOUND",
    CORPUS_SET_NOT_FOUND = "CORPUS_SET_NOT_FOUND",
    WORKING_SET_NOT_FOUND = "WORKING_SET_NOT_FOUND",
    VIEW_NOT_FOUND = "VIEW_NOT_FOUND",
    SAVED_SEARCH_NOT_FOUND = "SAVED_SEARCH_NOT_FOUND",
    ROLE_NOT_FOUND = "ROLE_NOT_FOUND",
    PERMISSION_MAP_NOT_FOUND = "PERMISSION_MAP_NOT_FOUND",
    SECURE_OBJECT_NOT_FOUND = "SECURE_OBJECT_NOT_FOUND",
    SECURE_OBJECT_IN_USE = "SECURE_OBJECT_IN_USE",
    ROLE_IN_USE = "ROLE_IN_USE",
    PERMISSION_MAP_INVALID = "PERMISSION_MAP_INVALID",
    MODEL_NOT_FOUND = "MODEL_NOT_FOUND",
    EXPORT_DB_CONNECTION_NOT_FOUND = "EXPORT_DB_CONNECTION_NOT_FOUND",
    CLIENT_CONTEXT_INVALID = "CLIENT_CONTEXT_INVALID",
    INVALID_STATE = "INVALID_STATE",
    DOMAIN_NOT_FOUND = "DOMAIN_NOT_FOUND",
    SCHEDULED_PROCESS_NOT_FOUND = "SCHEDULED_PROCESS_NOT_FOUND",
    PROCESS_NOT_FOUND = "PROCESS_NOT_FOUND",
    SCHEDULE_NOT_FOUND = "SCHEDULE_NOT_FOUND",
    REQUIRED_VERSION_MISMATCH = "REQUIRED_VERSION_MISMATCH",
    ALERT_CONDITION_NOT_FOUND = "ALERT_CONDITION_NOT_FOUND",
    DB_ERROR = "DB_ERROR",
    OBJECT_NOT_FOUND = "OBJECT_NOT_FOUND",
    MIGRATION_QUOTA_EXCEEDED = "MIGRATION_QUOTA_EXCEEDED",
    UNAUTHORIZED = "UNAUTHORIZED",
    NO_CAE_INSTANCE_FOUND = "NO_CAE_INSTANCE_FOUND",
    OBJECT_IS_LOCKED = "OBJECT_IS_LOCKED"
}

export enum StatusCode {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED',
    DELETE_PENDING = 'DELETE_PENDING',
    DELETE_REQUEST_PENDING = 'DELETE_REQUEST_PENDING',
    DISABLED = 'DISABLED',
    IMPORTING = 'IMPORTING',
    IMPORT_FAILED = 'IMPORT_FAILED',
}

export enum NotificationSeverityCode {
    INFO = 'INFO',
    WARN = 'WARN',
    ERROR = 'ERROR'
}

export enum AnalyticNodeMode {
    STANDARD = 'STANDARD',
    EXPRESS = 'EXPRESS',
    OCR = 'OCR'
}

export enum JobPriorityMode {
    Low = 'Low',
    Medium = 'Medium',
    High = 'High',
    NORMAL = 'Normal'
}

export enum MonitorStatus {
    AVAILABLE = 'AVAILABLE',
    WARNING = 'WARNING',
    UNKNOWN = 'UNKNOWN',
    FAILURE = 'FAILURE',
    PARTIAL_FAILURE = 'PARTIAL_FAILURE',
    NOT_LICENSED = 'NOT_LICENSED',
    DEACTIVATED = 'DEACTIVATED',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    CRITICAL = 'CRITICAL'
}

export enum MembershipType {
    group = 'group',
    project = 'project',
    organization = 'organization'
}

export enum DREnumType {
    ORG_DEFAULT_ROLE = 'ORG_DEFAULT_ROLE',
    SYSTEM_DEFAULT_ROLE = 'SYSTEM_DEFAULT_ROLE',
    AUX_PARSING_STATUS = 'AUX_PARSING_STATUS',
    FOLDER_BY_FIELD = 'FOLDER_BY_FIELD'
}

export enum ReviewSystem {
    REEF_REVIEW = 'ReefReview',
    RELATIVITY = 'Relativity',
    NONE = 'None',
    RELATIVITY_ONE = 'RelativityOne'
}

export enum AuthenticationMethod {
    PASSWORD_ONLY = 'Password only',
    EMAIL_CODE = 'Email Code',
    EMAIL_CODE_WITH_IP = 'Email Code + IP',
    EMAIL_CODE_IF_NOT_IP = 'Email Code if not IP',
    IP = 'IP'
}

export enum AuthenticationMethodTPAuth {
    TP_AUTH = 'TP Auth',
    TP_AUTH_WITH_IP = 'TP Auth + IP'
}

export enum OrganizationRole {
    CLAIMANT = 'Claimant',
    ORGANIZATION_ADMINISTRATOR = 'Organization Administrator',
    PROJECT_ADMINISTRATOR = 'Project Administrator',
    PROJECT_MEMBER = 'Project Member'
}

export enum SystemRole {
    SYSTEM_ADMINISTRATOR = 'System Administrator',
    SYSTEM_MANAGER = 'System Manager',
    SYSTEM_MEMBER = 'System Member'
}

export enum UserType {
    ORGANIZATION_USER = 'User',
    SYSTEM_USER = 'System User'
}

export enum ProjectMemberType {
    ORGANIZATION_USER = 'User',
    GROUP = 'Group',
    SYSTEM_USER = 'System User',
    SYSTEM_GROUP = 'System Group'
}

export enum Status {
    NOT_DISABLED_LOCKED = 'Not Disabled/Locked',
    LOCKED = 'Locked',
    DISABLED = 'Disabled',
    NOT_DISABLED = 'Not Disabled'
}

export enum LoadFileType {
    EDRM_XML = "EDRM_XML",
    CONCORDANCE_DAT = 'CONCORDANCE_DAT',
}

export enum SettingType {
    DR = "DR",
    RR = "RR",
    RS = "RS",
    RO = "RO"
}

export enum DiscardPileLogAction {
    RESTORE = 'Restore',
    DISCARD = 'Discard'
}

export enum HelpIndex {
    notice = 1150,

    object_permissions_dlg = 3015,
    select_users_for_obj_perms_dlg = 3038,
    select_search_targets_dlg = 3046,
    connectors_org_manage_dlg = 3071,
    org_groups_add_manage_dlg = 3074,
    project_data_areas_org_manage_dlg = 3075,
    org_roles_permissions_dlg = 3076,
    users_add_manage_org_dlg = 3077,
    save_as_template_dlg = 3092,
    select_connector_for_data_wiz_dlg = 3100,
    create_manifest_dlg = 3103,

    myedisc_welcome = 5000,
    myedisc_advanced_search = 5001,
    myedisc_simple_search_dlg_dlg = 5002,
    myedisc_bulk_search_dlg = 5003,
    myedisc_document_viewer_dlg = 5004,
    org_index_settings_template_dlg = 5005,
    org_analytic_settings_template_dlg = 5006,
    org_export_settings_template_dlg = 5007,
    org_tag_templates_org_dlg = 5008,
    org_doman_lists_template_dlg = 5009,
    org_metadata_template_dlg = 5010,
    org_survivorship_template_dlg = 5011,
    myedisc_case_analytic_settings_dlg = 5013,
    myedisc_case_tagmgmt_dlg = 5014,
    myedisc_case_domains_dlg = 5015,
    case_export_settings_dlg = 5016,
    myedisc_case_members_dlg = 5017,
    myedisc_case_metadata_view_config_dlg = 5018,
    case_survivorship_manage_dlg = 5019,
    myedisc_casesummarytab_dlg = 5020,
    myedisc_add_dynamicfolder_dlg = 5022,
    myedisc_save_search_query_dlg = 5023,
    myedisc_save_documents_to_dlg = 5025,
    myedisc_create_rule_name_dlg = 5026,
    myedisc_activerules_tab_dlg = 5027,
    myedisc_morelikethese_dlg = 5028,
    myedisc_morelikethis_dlg = 5029,
    myedisc_savedsearchview_dlg = 5030,
    myedisc_email_thread_viewer_dlg = 5031,
    myedisc_history_tab_dlg = 5032,
    myedisc_case_search_settings_dlg = 5033,
    myedisc_work_basket_new_dlg = 6001,
    myedisc_doc_lists_dlg = 5035,
    myedisc_add_domain_dlg = 5036,
    myedisc_add_domain_list_dlg = 5037,
    case_export_fields_dlg = 5038,
    case_permissions_roles_dlg = 5039,
    myedisc_member_select_popup_dlg = 5040,
    myedisc_add_edit_tag_dlg = 5041,
    myedisc_select_tags_menu_dlg = 5042,
    myedisc_email_threads_tab_dlg = 5044,
    myedisc_clusters_tab_dlg = 5045,
    myedisc_doc_search_results_dlg = 5046,
    myedisc_create_comparison_dlg = 5047,
    myedisc_create_sampledata_dlg = 5048,
    myedisc_custodian_summary_dlg = 5049,
    myedisc_search_results_report_dlg = 5050,
    myedisc_scan_report_summary_dlg = 5051,
    myedisc_scan_details_all_dlg = 5052,
    myedisc_per_custodian_report_dlg = 5053,
    myedisc_add_custodian_dlg = 5054,
    myedisc_discard_pile_dlg = 5056,
    myedisc_export_stream_docs_tab = 5057,
    myedisc_export_volume_docs = 5058,
    myedisc_exports_summary_dlg = 5059,
    myedisc_find_dupe_doc_dlg = 5061,
    details_single_tab_from_report_dlg = 5062,
    myedisc_bulk_search_report_dlg = 5063,
    myedisc_variations_report_dlg = 5064,
    myedisc_export_stream_settings = 5065,
    myedisc_export_stream_history_dlg = 5066,
    myedisc_recall_edit_active_rule = 5068,
    myedisc_activerule_sumlistview_dlg = 5069,
    myedisc_case_data_report_dlg = 5070,
    details_multiple_tabs_from_report_dlg = 5071,
    myedisc_searchhistoryview_dlg = 5072,
    myedisc_tag_details_from_report_dlg = 5073,
    myedisc_folders_summary_dlg = 5075,
    myedisc_comparisons_summary_dlg = 5076,
    myedisc_change_password_dlg = 5077,
    myedisc_word_list_report_dlg = 5078,
    myedisc_select_columns_for_doclist_dlg = 5080,
    myedisc_custodian_select_adv_search_dlg = 5082,
    myedisc_sampledata_summary_dlg = 5083,
    myedisc_zerodayreport_dlg = 5084,
    search_results_report_details_dlg = 5085,
    myedisc_create_manifest_dlg = 5086,
    myedisc_create_edit_profile_dlg = 5087,
    myedisc_run_search_by_profile_dlg = 5088,
    myedisc_profiles_summary = 5089,
    myedisc_profile_document_tab_dlg = 5090,
    myedisc_profile_history_tab_dlg = 5091,
    myedisc_select_profile = 5092,
    myedisc_case_search_fields_dlg = 5093,
    myedisc_case_alias_lists_dlg = 5094,
    myedisc_add_edit_alias_list_dlg = 5095,
    myedisc_add_alias_dlg = 5096,
    myedisc_sys_user_org_list_dash_dlg = 5097,
    myedisc_run_combined_search_dlg = 5098,
    myedisc_sourcedata_select_ad_search_dlg = 5099,
    myedisc_tags_summary_dlg = 5100,
    myedisc_case_preferences_dlg = 5101,
    myedisc_create_workflow_dlg = 5102,
    myedisc_workflows_summary_dlg = 5103,
    myedisc_edit_run_open_workflow_dlg = 5104,
    myedisc_eidt_workflow_name_desc_dlg = 5105,
    myedisc_query_search_selector_workflow_dlg = 5106,
    imports_datasets_summary_dlg = 5107,
    imports_add_data_to_case_dlg = 5108,
    import_options_dlg = 5109,
    create_connector_dlg = 5110,
    imports_update_data_set_dlg = 5111,
    copy_to_doc_storage_options_dlg = 5112,
    create_case_dlg = 5113,
    assign_members_dlg = 5114,
    case_creation_wiz_sum_dlg = 5115,
    imports_reports_dlg = 5116,
    case_audit_log = 5117,
    case_billing_report_information_dlg = 5118,
    imports_preview_custmed_locs_dlg = 5119,
    ediscfields_dlg = 5120,
    exports_ediscexports_summ_dlg = 5121,
    exports_ediscexports_dlg = 5122,
    exports_ediscexports_stream_docs_dlg = 5123,
    exports_ediscexports_stream_settings_dlg = 5124,
    exports_ediscexports_vol_docs_dlg = 5125,
    exports_ediscexports_vol_report_dlg = 5126,
    exports_ediscexports_vol_settings_dlg = 5127,
    exports_generate_load_file_dlg = 5128,
    export_data_areas_org_manage_dlg = 5129,
    org_export_db_manage_dlg = 5130,
    exports_stream_export_dupes_vol_dlg = 5131,
    exports_update_export_vol_dlg = 5132,
    review_sets_summary_dlg = 5133,
    review_set_create_dlg = 5134,
    exports_review_productions_summary_dlg = 5135,
    exports_new_review_production_dlg = 5136,
    exports_review_production_stream_settings_dlg = 5137,
    exports_review_production_volume_settings_dlg = 5138,
    exports_review_production_volume_report_dlg = 5139,
    review_set_stream_vol_settings_dlg = 5140,
    review_set_volume_report_dlg = 5141,
    review_sets_stream_docs_dlg = 5142,
    review_sets_volume_docs_dlg = 5143,
    reprocess_options_dlg = 5144,
    import_case_project_dlg = 5145,
    export_project_dlg = 5146,
    add_project_area_dlg = 5147,
    add_export_data_area_dlg = 5148,
    imports_add_shared_data_set_dlg = 5149,
    case_index_settings_dlg = 5150,
    copy_to_ext_area_reprocess_dlg = 5151,
    load_from_ext_area_reprocess_dlg = 5152,
    case_email_report_delivery_dlg = 5153,
    case_add_edit_export_metadata_profile_dlg = 5154,
    add_edit_export_group_field_dlg = 5155,
    add_custom_field_dlg = 5156,
    case_patterns_dlg = 5157,
    org_patterns_template_dlg = 5158,
    org_add_edit_template_generic_dlg = 5159,
    add_edit_email_signature_dlg = 5160,
    org_email_sig_template_dlg = 5161,
    case_email_signatures_dlg = 5162,
    add_edit_copy_pattern_dlg = 5163,
    case_billing_reports_manage_dlg = 5164,
    org_billing_reports_template_dlg = 5165,
    case_reports_manage_settings_dlg = 5166,
    org_reports_settings_template_dlg = 5167,
    connectors_org_manage = 5168,
    notification_email_wb_dlg = 5169,
    case_security_password_file_dlg = 5170,
    org_security_container_key_files_dlg = 5171,
    add_edit_container_key_file_dlg = 5172,
    case_custom_fields_dlg = 5173,
    org_custom_fields_template_dlg = 5174,
    org_search_options_template_dlg = 5175,
    select_templates_case_creation_dlg = 5176,
    org_alias_lists_template_dlg = 5177,
    org_load_file_import_settings_template = 5178,
    load_file_fields_tab_dlg = 5179,
    load_file_settings_tab_dlg = 5180,
    load_file_create_composite_field_dlg = 5181,
    load_file_discover_fields_tab = 5182,
    case_data_exports_review_sets_summary_dlg = 5183,
    create_dataset_from_result_dlg = 5184,
    case_level_monitoring_dlg = 5185,
    generate_export_comparison_report_dlg = 5186,
    export_comparison_report_dlg = 5187,
    generate_workflow_report_run_dlg = 5188,
    imports_add_load_file_dlg = 5189,
    case_load_file_import_settings_dlg = 5190,
    case_wb_permissions_dlg = 5191,
    shared_datasets_org_manage_dlg = 5192,
    load_from_template_dlg = 5193,
    workflow_report_view_download_dlg = 5194,
    download_word_list_dlg = 5195,
    update_custodians_exportstream_dlg = 5196,
    update_metadata_dlg = 5197,
    generate_more_reports_workflow_dlg = 5198,
    review_production_select_codes_dlg = 5199,
    case_billing_summary_filetype_details_dlg = 5200,
    case_dashboard_dlg = 5201,
    exports_create_near_dupe_meta_dlg = 5202,
    edit_case_name_dlg = 5203,
    add_edit_code_stamp_case_dlg = 5204,
    case_code_based_prod_stamping_dlg = 5205,
    add_edit_custom_slipsheet_case_dlg = 5206,
    case_custom_slipsheet_dlg = 5207,
    external_imaging_copy_for_dlg = 5208,
    external_image_import_dlg = 5209,
    automatic_ocr_settings = 5210,
    exports_generate_custodian_reports_dlg = 5211,
    org_search_fields_template_dlg = 5212,
    org_export_fields_template_dlg = 5213,
    imports_edit_data_set_name_dlg = 6000,
    review_admin_add_code_dlg = 7010,
    review_admin_settings_persisthigh_groups_dlg = 7012,
    review_admin_create_new_persh_group_dlg = 7013,
    case_keyboard_shortcut_settings_dlg = 7020,
    case_keyboard_shortcut_settings_reviewer_dlg = 7021,
    review_create_batch_folder_dlg = 7028,
    review_admin_add_edit_code_set_dlg = 7035,
    review_manage_users_dlg = 7036,
    review_settings_autoredact_dlg = 7042,
    case_propagation_settings_dlg = 7043,
    ediscovery_review_workspace = 7055,
    admin_manage_settings_dlg = 7053,
    organization_mgmt_overview = 7054,
    imports_reindex_data_set_dlg = 7056,
    imports_view_configuration_dlg = 7057,
    work_basket_details_dlg = 7058,
    add_edit_org_export_db_dlg = 7059,
    load_file_date_transformer_dlg = 7060,
    load_file_number_transformer_dlg = 7061,
    load_file_text_transformer_dlg = 7062,
    project_data_doc_lists_dlg = 7063,
    project_data_doc_search_results_dlg = 7064,
    add_edit_user_dlg = 7065,
    add_edit_org_group_dlg = 7066,
    ediscovery_document_viewer_5x_dlg = 7069,
    add_edit_copy_role = 7068,
    select_connector_file_bulksearch_dlg = 7070,
    myedisc_comparison_view_dlg = 7071,
    exports_edit_export_name_desc_dlg = 7072,
    scan_history_dlg = 7073,
    systemsettingsoverview = 7074,
    sys_template_analytic_dlg = 7075,
    sys_template_billing_dlg = 7076,
    sys_template_domain_lists_dlg = 7077,
    sys_template_excluded_content_dlg = 7078,
    sys_template_export_fields_dlg = 7079,
    sys_template_export_settings_dlg = 7080,
    sys_template_index_settings_dlg = 7081,
    sys_template_metadata_search_fields_dlg = 7082,
    sys_template_metadata_view_fields_dlg = 7083,
    sys_template_patterns_dlg = 7084,
    sys_template_reports_dlg = 7085,
    sys_template_search_settings_dlg = 7086,
    sys_template_surv_model_dlg = 7087,
    sys_template_tags_dlg = 7088,
    password_view_found_passwords_dlg = 7089,
    password_view_edit_known_passwords_dlg = 7090,
    password_add_passwords_dlg = 7091,
    password_view_edit_freqused_passwords_dlg = 7092,
    sys_job_mgmt_dlg = 7093,
    sys_job_live_log_dlg = 7094,
    sys_job_notification_dlg = 7095,
    promotion_tracker_notification_dlg = 7095,
    sys_user_active_sessions_dlg = 7096,
    sys_template_profiles_dlg = 7097,
    sys_template_profiles_savetoorgs_dlg = 7098,
    find_in_tree_dlg = 7099,
    generate_processing_report_information_dlg = 7100,
    metadata_list_dlg = 7101,
    sys_job_history_dlg = 7102,
    org_storage_dlg = 7103,
    sys_projects_dlg = 7104, // skipping 7105
    sys_projects_change_service = 7106,
    sys_set_passwd_logout_pol_dlg = 7107,
    sys_set_mailserver_notif_dlg = 7108,
    sys_set_system_storage_depot_dlg = 7109,
    sys_set_virus_detect_updates_dlg = 7110,
    sys_set_system_message_dlg = 7111,
    sys_deleted_projects_dlg = 7113,
    sys_delete_pending_projects_dlg = 7112,
    mediaidview_summary_dlg = 7114,
    add_edit_mediaidview_dlg = 7115,
    batchview_summary_dlg = 7116,
    add_edit_batchview_dlg = 7117,
    system_users_manage_dlg = 7118,
    add_edit_system_user_dlg = 7119,
    system_groups_manage_dlg = 7120,
    add_edit_system_group_dlg = 7121,
    generate_cluster_report_dlg = 7122,
    build_rebuild_clusters_dlg = 7123,
    sys_license_dlg = 7124,
    email_comm_matrix_dlg = 7125,
    domains_matrix_dlg = 7126,
    system_roles_permissions_dlg = 7127,
    imports_add_ds_short_message_format_dlg = 7128,
    org_member_select_popup_dlg = 7129,
    sys_org_summary_dlg = 7130,
    sys_add_org_dlg = 7131,
    extract_office_365_data_dlg = 7132,
    sys_realm_node_summary_dlg = 7133,
    sys_add_realm_node_dlg = 7134,
    sys_storage_summary_dlg = 7135,
    sys_add_edit_storage_dlg = 7136,
    sys_services_summary_dlg = 7137,
    sys_add_edit_services_dlg = 7138,
    add_to_domain_list_dlg = 7139,
    sys_monitoring_dlg = 7140,
    sys_ocr_usage_report_download_dlg = 7141,
    sys_set_reef_review_dlg = 7142,
    project_member_select_popup_dlg = 7143,
    sys_proj_access_history_dlg = 7144,
    sys_reefreview_tracker_dlg = 7145,
    sys_audit_log_dlg = 7146,
    org_workflow_template_dlg = 7147,
    discard_pile_log_dlg = 7148,
    generate_data_set_report_dlg = 7149,
    create_case_select_review_template_dlg = 7150,
    create_case_select_review_client_dlg = 7151,
    create_case_select_review_projects_dlg = 7152,
    sys_set_review_system = 7153

    // IMPORTANT = do NOT add any ids to this section without Leslie's approval.
    // This is because there has been a lot of renaming and remapping of the help topics
    // so if you are looking for a previously existing help topic, it may have been renamed.
    // Also, try to keep these in ascending order by id
}

